export const FETCH_EXPORTREQUEST_ERROR =
  'Não foi possível realizar a nova exportação de dados no momento.';

export const FETCH_CLINICPHYSICIANS_ERROR =
  'Não foi possível obter a lista de profissionais no momento.';
